<template>
  <div class="percentage-bar">
    <div
      class="percentage-bar-inner"
      :class="`rating-${rating}`"
      :style="{ width: `${percentage}%` }"
    />
  </div>
</template>

<script lang="ts" setup>
import type { TRating } from './types';

type TProps = {
  percentage: number;
  rating: TRating;
};

defineProps<TProps>();
</script>

<style lang="scss" scoped>
.percentage-bar {
  width: 100%;
  height: 4px;
  background-color: $bdcolor-light;
  border-radius: 100px;
  position: relative;
  overflow: hidden;

  .percentage-bar-inner {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }
}

.rating-fail {
  &.percentage-bar-inner {
    background-color: $basecolor-error;
  }
}
.rating-passable {
  &.percentage-bar-inner {
    background-color: $basecolor-secondary;
  }
}
.rating-good {
  &.percentage-bar-inner {
    background-color: $basecolor-success;
  }
}
</style>

